import React from 'react'

const Manual_configuracion_envio_pickup = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          Configuración del Método de Envío: Pickup en Clau
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Aprende a configurar el método de entrega “Pickup” para permitir que los clientes recojan sus pedidos en tienda.
        </p>
        <iframe
          src="https://scribehow.com/embed/Configuracion_del_Metodo_de_Envio_Pickup_en_Clau__h0l7IDayRn2kVaaDYfFT6g?as=scrollable"
          className="scribe-iframe-general-113"
          width="100%"
          height="6800"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_configuracion_envio_pickup
